import { render, staticRenderFns } from "./carcass.vue?vue&type=template&id=0380f681&"
import script from "./carcass.vue?vue&type=script&lang=js&"
export * from "./carcass.vue?vue&type=script&lang=js&"
import style0 from "./carcass.vue?vue&type=style&index=0&id=0380f681&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports